import { render, staticRenderFns } from "./MentalApp.vue?vue&type=template&id=6aa4970c&"
import script from "./MentalApp.vue?vue&type=script&lang=js&"
export * from "./MentalApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports